webpackJsonp([5],{

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("j1ja");
module.exports = __webpack_require__("NHnr");


/***/ }),

/***/ "1fCB":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticClass: "wrap"
  }, [_vm._v(_vm._s(_vm.text))]) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ "1lpI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.showToast = exports.registryToast = undefined;

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _toast = __webpack_require__("Wud8");

var _toast2 = _interopRequireDefault(_toast);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ToastConstructor = _vue2.default.extend(_toast2.default);

function showToast(text) {
  var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2000;

  var toastDom = new ToastConstructor({
    el: document.createElement('div'),
    data: function data() {
      return {
        text: text,
        show: true
      };
    }
  });
  document.body.appendChild(toastDom.$el);
  setTimeout(function () {
    toastDom.show = false;
  }, duration);
}

function registryToast() {
  _vue2.default.prototype.$toast = showToast;
}

exports.registryToast = registryToast;
exports.showToast = showToast;

/***/ }),

/***/ "3r5k":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _assign = __webpack_require__("woOf");

var _assign2 = _interopRequireDefault(_assign);

var _typeof2 = __webpack_require__("pFYg");

var _typeof3 = _interopRequireDefault(_typeof2);

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

var _qs = __webpack_require__("mw3O");

var _qs2 = _interopRequireDefault(_qs);

var _cookie = __webpack_require__("P5P/");

var _cookie2 = _interopRequireDefault(_cookie);

var _toast = __webpack_require__("1lpI");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Ajax = function () {
  function Ajax(options) {
    var _this = this;

    (0, _classCallCheck3.default)(this, Ajax);

    this.$http = _axios2.default;
    this.baseUrl = options && options.baseUrl ? options.baseUrl : '/api/v1';
    this.authUrl = options && options.authUrl ? options.authUrl : '/auth/weixin';

    this.$store = null;
    this.isLogin = false;
    this.queryMap = {};
    this.createMap = {};
    this.putWayMap = {};
    this.patchMap = {};
    this.deleteMap = {};
    this.next = '';

    this.showTips = function (tips) {
      if (window.console) {
        console.log(tips);
      }
    };

    if (options && typeof options.success === 'function') {
      this.success = options.success;
    } else {
      this.success = function (res) {};
    }

    _axios2.default.interceptors.request.use(function (config) {
      var csrftoken = _cookie2.default.getCookie('csrf-token');
      if (!/^(GET|HEAD|OPTIONS|TRACE)$/i.test(config.method) && !_axios2.default.credentials) {
        config.headers.common['X-CSRF-Token'] = csrftoken;
      }
      return config;
    }, function (err) {
      return _promise2.default.reject(err);
    });

    _axios2.default.interceptors.response.use(function (response) {
      if (response.data.code !== 0) {
        (0, _toast.showToast)(response.data.message);
      }
      _this.success(response);
      return response;
    }, function (err) {
      if (err.response) {
        switch (err.response.status) {
          case 404:
            (0, _toast.showToast)('请求发生404错误');
            break;
          case 500:
            (0, _toast.showToast)('请求发生500错误');
            break;
          case 504:
            (0, _toast.showToast)('请求超时');
            break;
          case 400:
          case 401:
            var backUrl = '/';
            var next = '';
            if (window.location.hash === '') {
              next = backUrl = encodeURIComponent('/');
            } else {
              backUrl = encodeURIComponent(window.location.hash.substring(1));
              next = encodeURIComponent(window.location.hash);
            }
            window.location.href = location.origin;
            break;
          case 429:
            (0, _toast.showToast)('获取验证码超出次数限制');
            break;
          default:
            (0, _toast.showToast)('error:' + err.response.status);
            break;
        }
        var res = _this.normalizeRes(err.response);
        return _promise2.default.reject(res.data);
      }
    });
  }

  (0, _createClass3.default)(Ajax, [{
    key: 'normalizeRes',
    value: function normalizeRes(res) {
      if (res && typeof res.data === 'string') {
        res.data = {
          code: -1,
          message: res.data
        };
      } else if (res && res.statusText) {
        res.data = {
          code: res.status,
          message: res.statusText
        };
      } else {
        res = {
          data: {
            code: -1,
            message: '未知错误'
          }
        };
      }
      return res;
    }
  }, {
    key: 'setStore',
    value: function setStore(store) {
      this.$store = store;
    }
  }, {
    key: 'setTipFn',
    value: function setTipFn(fn) {
      this.showTips = fn;
    }
  }, {
    key: 'setSuccess',
    value: function setSuccess(success) {
      this.success = success;
    }
  }, {
    key: 'parse',
    value: function parse(path, id) {
      if (typeof id === 'string') {
        return path + '/' + id;
      }
      if ((typeof id === 'undefined' ? 'undefined' : (0, _typeof3.default)(id)) === 'object') {
        var search = '?';
        var counter = 0;
        for (var key in id) {
          if (counter) search += '&';
          search += key + '=' + id[key];
          counter++;
        }
        return path + search;
      }
      return path;
    }
  }, {
    key: 'query',
    value: function query(path) {
      var _this2 = this;

      var config1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { cache: false };

      if (!this.queryMap[path]) {
        var url = '';
        this.queryMap[path] = function (id, expand) {
          var config2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
          var isReturnRes = arguments[3];

          var config = (0, _assign2.default)({}, config1, config2);

          if (!config.cache) {
            var headers = config.headers = config.headers || {};
            headers['Cache-Control'] = 'no-cahce';
            headers['If-Modified-Since'] = '0';
          }
          url = expand ? path + '/' + expand : path;
          var newPath = id ? _this2.parse(url, id) : url;
          var baseUrl = config.baseUrl || _this2.baseUrl;
          return _this2.$http.get(baseUrl + newPath, config).then(function (res) {
            return isReturnRes ? res : res.data;
          }, function (res) {
            return res;
          }).catch(function (res) {
            throw new Error((0, _stringify2.default)(res));
          });
        };
      }
      return this.queryMap[path];
    }
  }, {
    key: 'create',
    value: function create(path) {
      var _this3 = this;

      var config1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { cache: false };

      if (!this.createMap[path]) {
        var url = '';
        this.createMap[path] = function (data, expand) {
          var config2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
          var isReturnRes = arguments[3];

          var config = (0, _assign2.default)({}, config1, config2);

          if (!config.cache) {
            var headers = config.headers = config.headers || {};
            headers['Cache-Control'] = 'no-cahce';
            headers['If-Modified-Since'] = '0';
          }

          if (config.emulateJSON) {
            data = _qs2.default.stringify(data);
          }
          url = expand ? url = path + '/' + expand : path;
          var baseUrl = config.baseUrl || _this3.baseUrl;
          return _this3.$http.post(baseUrl + url, data, config).then(function (res) {
            return isReturnRes ? res : res.data;
          }, function (res) {
            return res;
          }).catch(function (res) {
            throw new Error((0, _stringify2.default)(res));
          });
        };
      }
      return this.createMap[path];
    }
  }, {
    key: 'putWay',
    value: function putWay(path) {
      var _this4 = this;

      var config1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { cache: false };

      if (!this.putWayMap[path]) {
        var url = '';
        this.putWayMap[path] = function (data, expand) {
          var config2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
          var isReturnRes = arguments[3];

          var config = (0, _assign2.default)({}, config1, config2);

          if (!config.cache) {
            var headers = config.headers = config.headers || {};
            headers['Cache-Control'] = 'no-cahce';
            headers['If-Modified-Since'] = '0';
          }

          if (config.emulateJSON) {
            data = _qs2.default.stringify(data);
          }
          url = expand ? url = path + '/' + expand : path;
          var baseUrl = config.baseUrl || _this4.baseUrl;
          return _this4.$http.put(baseUrl + url, data, config).then(function (res) {
            return isReturnRes ? res : res.data;
          }, function (res) {
            return res;
          }).catch(function (res) {
            throw new Error((0, _stringify2.default)(res));
          });
        };
      }
      return this.putWayMap[path];
    }
  }, {
    key: 'patch',
    value: function patch(path) {
      var _this5 = this;

      var config1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { cache: false };

      if (!this.patchMap[path]) {
        var url = '';
        this.patchMap[path] = function (data, expand) {
          var config2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

          var config = (0, _assign2.default)({}, config1, config2);

          if (!config.cache) {
            var headers = config.headers = config.headers || {};
            headers['Cache-Control'] = 'no-cahce';
            headers['If-Modified-Since'] = '0';
          }

          if (config.emulateJSON) {
            data = _qs2.default.stringify(data);
          }
          url = expand ? url = path + '/' + expand : path;
          var baseUrl = config.baseUrl || _this5.baseUrl;
          return _this5.$http.patch(baseUrl + url, data, config).then(function (res) {
            return res.data;
          }, function (res) {
            return res;
          }).catch(function (res) {
            throw new Error((0, _stringify2.default)(res));
          });
        };
      }
      return this.patchMap[path];
    }
  }, {
    key: 'delete',
    value: function _delete(path) {
      var _this6 = this;

      var config1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { cache: false };

      if (!this.deleteMap[path]) {
        var url = '';
        this.deleteMap[path] = function (data, expand) {
          var config2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

          var config = (0, _assign2.default)({}, config1, config2);

          if (!config.cache) {
            var headers = config.headers = config.headers || {};
            headers['Cache-Control'] = 'no-cahce';
            headers['If-Modified-Since'] = '0';
          }

          if (config.emulateJSON) {
            data = _qs2.default.stringify(data);
          }
          url = expand ? url = path + '/' + expand : path;
          var baseUrl = config.baseUrl || _this6.baseUrl;
          return _this6.$http.delete(baseUrl + url, data, config).then(function (res) {
            return res.data;
          }, function (res) {
            return res;
          }).catch(function (res) {
            throw new Error((0, _stringify2.default)(res));
          });
        };
      }
      return this.deleteMap[path];
    }
  }]);
  return Ajax;
}();

exports.default = new Ajax();

/***/ }),

/***/ "4jwz":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "head"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', {
    staticClass: "sub-title"
  }, [_vm._v("（" + _vm._s(_vm._f("coverPhone")(_vm.subTitle)) + "）")]), _vm._v(" "), (_vm.date) ? _c('span', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm.date))]) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ "A/kv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      formData: {
        phone: '',
        picCode: '',
        smsCode: ''
      },
      veryPic: '',
      count: 60,
      canGetMsm: true
    };
  },

  computed: {
    countText: function countText() {
      if (this.canGetMsm) {
        return '获取验证码';
      } else {
        return this.count + 's';
      }
    }
  },
  created: function created() {
    var _this = this;

    this.$rest.personal.checkAuth().then(function (res) {
      if (res.code === 0 && res.data.is_authenticated) {
        if (res.data.is_authenticated) {
          _this.$router.push({ path: 'calendar' });
        }
      }
    });
    this.getPicCode();
  },

  methods: {
    getPicCode: function getPicCode() {
      this.veryPic = '/auth/captcha?' + Math.random();
      this.formData.picCode = '';
    },
    judgeMsm: function judgeMsm() {
      var _formData = this.formData,
          phone = _formData.phone,
          picCode = _formData.picCode;

      return phone && /^1\d{10}$/.test(phone) && picCode;
    },
    getMsmCode: function getMsmCode() {
      var _this2 = this;

      if (this.judgeMsm) {
        this.$rest.personal.getMsmCode(this.formData).then(function (res) {
          if (res.code === 0) {
            _this2.canGetMsm = false;

            _this2.timer = setInterval(function () {
              if (_this2.count > 1) {
                _this2.count--;
              } else {
                _this2.count = 60;
                _this2.canGetMsm = true;
                clearInterval(_this2.timer);
              }
            }, 1000);
          }
        });
      }
    },
    login: function login() {
      var _this3 = this;

      this.$rest.personal.login(this.formData).then(function (res) {
        if (res.code === 0) {
          localStorage.removeItem('userInfo');
          localStorage.setItem('userInfo', (0, _stringify2.default)(res.data));
          _this3.$router.push({ path: 'calendar' });
        }
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.timer && clearInterval(this.timer);
  }
};

/***/ }),

/***/ "Aulo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Az0D":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    date: {
      type: String
    }
  },
  data: function data() {
    return {
      title: '',
      subTitle: ''
    };
  },
  mounted: function mounted() {
    try {
      var _JSON$parse = JSON.parse(localStorage.getItem('userInfo')),
          dealer_name = _JSON$parse.dealer_name,
          phone = _JSON$parse.phone;

      this.title = dealer_name;
      this.subTitle = phone;
    } catch (e) {
      console.error(e);
    }
  }
};

/***/ }),

/***/ "CXu2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  if (!window.localStorage || !window.sessionStorage) {
    this.buffer.nonMark = true;
  } else {
    try {
      window.localStorage.setItem('test', {});
      window.sessionStorage.setItem('test', {});
    } catch (e) {
      this.buffer.nonMark = true;
    }
  }
})();
exports.default = {
  buffer: {
    nonMark: false,
    zsData: {
      localData: {},
      sessionData: {} }
  },
  keyMap: {
    'CACHE_STORE_ID': 'cache_store_id',
    'CACHE_STORE_STATUS': 'cache_store_status'
  },
  setSessionData: function setSessionData(key, val) {
    if (!this.buffer.nonMark && window.sessionStorage.setItem) {
      try {
        window.sessionStorage.setItem(key, (0, _stringify2.default)(val));
      } catch (e) {
        this.buffer.nonMark = true;
        this.buffer.zsData.sessionData[key] = val;
      }
    } else {
      this.buffer.zsData.sessionData[key] = val;
    }
  },
  getSessionData: function getSessionData(key) {
    if (!this.buffer.nonMark && window.sessionStorage.getItem) {
      var val = window.sessionStorage.getItem(key);
      return val === null || val === '' ? val : JSON.parse(val);
    } else {
      return this.buffer.zsData.sessionData[key];
    }
  },
  setLocalStorageData: function setLocalStorageData(key, val) {
    if (!this.buffer.nonMark && window.localStorage.setItem) {
      try {
        window.localStorage.setItem(key, (0, _stringify2.default)(val));
      } catch (e) {
        this.buffer.nonMark = true;
        this.buffer.zsData.localData[key] = val;
      }
    } else {
      this.buffer.zsData.localData[key] = val;
    }
  },
  getLocalStorageData: function getLocalStorageData(key) {
    if (!this.buffer.nonMark && window.localStorage.getItem) {
      var val = window.localStorage.getItem(key);
      return val === null || val === '' ? val : JSON.parse(val);
    } else {
      return this.buffer.zsData.localData[key];
    }
  },
  clearSessionData: function clearSessionData(key) {
    if (window.sessionStorage.removeItem && !this.buffer.nonMark) {
      window.sessionStorage.removeItem(key);
    } else {
      this.buffer.zsData.sessionData[key] = [];
    }
  },
  clearLocalStorageData: function clearLocalStorageData(key) {
    if (window.localStorage.removeItem && !this.buffer.nonMark) {
      window.localStorage.removeItem(key);
    } else {
      this.buffer.zsData.localData[key] = [];
    }
  }
};

/***/ }),

/***/ "E5VZ":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("s22o")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("A/kv"),
  /* template */
  __webpack_require__("wG7n"),
  /* scopeId */
  "data-v-0695aff5",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "Jl4W":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ajax = __webpack_require__("3r5k");

var _ajax2 = _interopRequireDefault(_ajax);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  personal: {
    checkAuth: _ajax2.default.query('/check_login_status', { baseUrl: '/auth' }),
    getMsmCode: _ajax2.default.create('/verification_code', { baseUrl: '/auth' }),
    login: _ajax2.default.create('/login', { baseUrl: '/auth' })
  },
  dataReport: {
    getCalendarData: _ajax2.default.query('/report/list_calendar_date'),

    dailyDetails: _ajax2.default.query('/report/daily_details'),

    monthlyDetail: _ajax2.default.query('/report/monthly_details'),

    create: _ajax2.default.create('/report/create'),

    edit: function edit(id) {
      return _ajax2.default.patch('/report/edit/' + id);
    }
  }
};

/***/ }),

/***/ "JlJn":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("UJIV")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("Ze4+"),
  /* template */
  __webpack_require__("MzWC"),
  /* scopeId */
  "data-v-5409baec",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "M93x":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("Aulo")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("tV7e"),
  /* template */
  __webpack_require__("vB6W"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "MzWC":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('reportHeader'), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated bounceIn  ",
      "leave-active-class": "animated bounceOut"
    }
  }, [_c('article', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCalendar),
      expression: "showCalendar"
    }],
    staticClass: "calendar-body",
    on: {
      "touchstart": _vm.calendarTouchStart,
      "touchmove": _vm.calendarTouchMove,
      "touchend": _vm.calendarTouchEnd
    }
  }, [_c('header', {
    staticClass: "head-title"
  }, [_c('a', {
    staticClass: "icon-arrow arrow-left with_arrow",
    attrs: {
      "href": "javascript: void(0)"
    },
    on: {
      "click": function($event) {
        return _vm.adjacentMonth('prev')
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "date"
  }, [_vm._v(_vm._s(this.calendar.getMonthHead()))]), _vm._v(" "), _c('a', {
    class: ['icon-arrow', 'arrow-right', 'with_arrow', {
      disabled: !_vm.calendar.canGetNext()
    }],
    attrs: {
      "href": "javascript: void(0)"
    },
    on: {
      "click": function($event) {
        return _vm.adjacentMonth('next')
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "week"
  }, _vm._l((_vm.week), function(item) {
    return _c('span', {
      key: item
    }, [_vm._v(_vm._s(item))])
  }), 0), _vm._v(" "), _c('ul', {
    staticClass: "days"
  }, _vm._l((_vm.calendar.days), function(date, i) {
    return _c('li', {
      key: date.day,
      staticClass: "day",
      style: ({
        marginLeft: i === 0 ? ((_vm.calendar.frontSpace * 1.14) + "rem") : '0'
      }),
      on: {
        "click": function($event) {
          return _vm.handleDayClick(date)
        }
      }
    }, [_c('span', {
      class: ['item', {
        reported: date.state === 'reported'
      }, {
        'can-report': date.state === 'canReport'
      }]
    }, [_vm._v("\n          " + _vm._s(+date.day) + "\n        ")])])
  }), 0), _vm._v(" "), _c('button', {
    staticClass: "total-data",
    on: {
      "click": _vm.handleMonthClick
    }
  }, [_vm._v("月汇总数据")])])]), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "foot"
  }, [_c('span', {
    staticClass: "reported"
  }, [_vm._v("已上报")]), _vm._v(" "), _c('span', {
    staticClass: "can-report"
  }, [_vm._v("未上报")]), _vm._v(" "), _c('span', {
    staticClass: "other"
  }, [_vm._v("点击日期可查看当天数据")])])
}]}

/***/ }),

/***/ "NHnr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("UHcj");

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _report = __webpack_require__("l+Iq");

var _report2 = _interopRequireDefault(_report);

var _store = __webpack_require__("YtJ0");

var _store2 = _interopRequireDefault(_store);

var _rest = __webpack_require__("i4WM");

var _rest2 = _interopRequireDefault(_rest);

var _router = __webpack_require__("YaEn");

var _router2 = _interopRequireDefault(_router);

__webpack_require__("w0a6");

__webpack_require__("q3JJ");

var _index = __webpack_require__("1lpI");

var _validate = __webpack_require__("zfoQ");

var _validate2 = _interopRequireDefault(_validate);

var _reportPlugin = __webpack_require__("Tn1B");

var _reportPlugin2 = _interopRequireDefault(_reportPlugin);

var _App = __webpack_require__("M93x");

var _App2 = _interopRequireDefault(_App);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.config.productionTip = false;

_vue2.default.use(_index.registryToast);

_vue2.default.use(_validate2.default);
_vue2.default.use(_reportPlugin2.default);

new _vue2.default({
  el: '#app',
  router: _router2.default,
  store: _store2.default,
  rest: _rest2.default,
  report: _report2.default,
  template: '<App/>',
  components: { App: _App2.default }
});

/***/ }),

/***/ "P5P/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  getCookie: function getCookie(name) {
    var c = document.cookie;
    if (c.length > 0) {
      var s = c.indexOf(name + '=');
      if (s !== -1) {
        s = s + name.length + 1;
        var e = c.indexOf(';', s);
        if (e === -1) {
          e = c.length;
        }
        return unescape(c.substring(s, e));
      }
    }
    return '';
  }
};

/***/ }),

/***/ "T5mV":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("tcoz")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("Az0D"),
  /* template */
  __webpack_require__("4jwz"),
  /* scopeId */
  "data-v-f6130152",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "Tn1B":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var reportPlugin = {
  install: function install(Vue, options) {
    Vue.filter('toThousands', function () {
      var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var digit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
      var prefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var suffix = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

      val = val.toString();

      if (val === '--') return val;
      if (/.*%$/.test(val)) {
        val = +val.replace(/%/g, '');
        suffix = '%';
      }
      val = +val;
      digit = digit > 0 && digit <= 20 ? digit : 2;
      val = parseFloat((val + '').replace(/^\d\.-/g, '')).toFixed(digit) + '';
      var l = val.split('.')[0].split('').reverse();
      var r = val.split('.')[1];
      var t = '';
      for (var i = 0; i < l.length; i++) {
        t += l[i] + ((i + 1) % 3 === 0 && i + 1 !== l.length ? ',' : '');
      }
      var res = t.split('').reverse().join('') + '.' + r;
      res = res.replace(/\.00$/, '').replace(/^-,/, '-');
      return prefix + res + suffix;
    });

    Vue.filter('coverPhone', function (phone) {
      var perch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '*';

      if (typeof phone === 'number') {
        phone = phone.toString();
      }
      return phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
    });

    Vue.filter('tenThousand', function () {
      var num = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var digit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10000;
      var suffix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '万';

      return (num / digit).toFixed(2) + suffix;
    });

    Vue.directive('ellipsis', {
      inserted: function inserted(el, _ref) {
        var value = _ref.value,
            modifiers = _ref.modifiers;

        var text = el.innerHTML;
        text.length > value && (el.innerHTML = text.substr(0, value) + '...');
        text.length > value && !modifiers.noTip && el.setAttribute('title', text);
      }
    });
  }
};

exports.default = reportPlugin;

/***/ }),

/***/ "TzB0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function makeRes(res) {
  var msg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '信息未填写完整';

  if (!res) {
    return {
      pass: false,
      msg: msg
    };
  }
  return {
    pass: true
  };
}

function parseNum(fun) {
  return function (val) {
    val = typeof val !== 'string' ? val + '' : val;
    return fun(val);
  };
}

var rules = {
  required: parseNum(function (value) {
    return makeRes(value && value.trim() !== '');
  }),
  validatePhone: parseNum(function (value) {
    return makeRes(/^1\d{10}$/.test(value), '请输入正确的手机号码');
  }),
  twoDecimals: parseNum(function (value) {
    return makeRes(/^\d{0,7}(\.\d{1,2})?$/.test(value), '最大7为正整数，2位小数');
  }),
  sevenDigit: parseNum(function (value) {
    return makeRes(/^\d{0,7}$/.test(value), '最大7为正整数');
  })
};

var handleStyles = {
  textRed: function textRed(validateFun, e, vNode) {
    var correctPhone = validateFun(vNode.elm.value);
    var originClassName = vNode.elm.parentElement.className;

    vNode.elm.parentElement.className = originClassName.replace(/check-error/g, '').trim();
    if (!correctPhone.pass) {
      vNode.elm.parentElement.className = originClassName + ' check-error';
    }
    return correctPhone;
  },
  textNormal: function textNormal(e, vNode) {
    var originClassName = vNode.elm.parentElement.className;
    vNode.elm.parentElement.className = originClassName.replace(/check-error/g, '').trim();
  }
};

var Validation = function () {
  function Validation() {
    (0, _classCallCheck3.default)(this, Validation);

    this.rules = rules;
    this.handleStyles = handleStyles;
    this.errorObj = {};
  }

  (0, _createClass3.default)(Validation, [{
    key: 'addErrorObj',
    value: function addErrorObj(key, el, msg) {
      this.errorObj[key] = {
        el: el, msg: msg
      };
    }
  }, {
    key: 'delErrorObj',
    value: function delErrorObj(key) {
      delete this.errorObj[key];
    }
  }, {
    key: 'resetErrorObj',
    value: function resetErrorObj() {
      this.errorObj = {};
    }
  }, {
    key: 'hasError',
    value: function hasError() {
      return (0, _stringify2.default)(this.errorObj) !== '{}';
    }
  }, {
    key: 'getError',
    value: function getError() {
      for (var i in this.errorObj) {
        return this.errorObj[i];
      }
    }
  }, {
    key: 'addOneError',
    value: function addOneError(key, el, msg) {
      this.errorObj[key] = {
        el: el, msg: msg
      };
    }
  }]);
  return Validation;
}();

exports.default = Validation;

/***/ }),

/***/ "UHcj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (win, lib) {
  var doc = win.document;
  var docEl = doc.documentElement;
  var metaEl = doc.querySelector('meta[name="viewport"]');
  var flexibleEl = doc.querySelector('meta[name="flexible"]');
  var dpr = 0;
  var scale = 0;
  var tid = null;
  var flexible = lib.flexible || (lib.flexible = {});

  if (metaEl) {
    var match = metaEl.getAttribute('content').match(/initial-scale=([\d]+)/);
    if (match) {
      scale = parseFloat(match[1]);
      dpr = parseInt(1 / scale);
    }
  } else if (flexibleEl) {
    var content = flexibleEl.getAttribute('content');
    if (content) {
      var initialDpr = content.match(/initial-dpr=([\d]+)/);
      var maximumDpr = content.match(/maximum-dpr=([\d]+)/);
      if (initialDpr) {
        dpr = parseFloat(initialDpr[1]);
        scale = parseFloat((1 / dpr).toFixed(2));
      }
      if (maximumDpr) {
        dpr = parseFloat(maximumDpr[1]);
        scale = parseFloat((1 / dpr).toFixed(2));
      }
    }
  }

  if (!dpr && !scale) {
    var isIPhone = win.navigator.appVersion.match(/iphone/gi);
    var devicePixelRatio = win.devicePixelRatio;
    if (isIPhone) {
      if (devicePixelRatio >= 3 && (!dpr || dpr >= 3)) {
        dpr = 3;
      } else if (devicePixelRatio >= 2 && (!dpr || dpr >= 2)) {
        dpr = 2;
      } else {
        dpr = 1;
      }
    } else {
      dpr = 1;
    }
    scale = 1 / dpr;
  }

  docEl.setAttribute('data-dpr', dpr);
  if (!metaEl) {
    metaEl = doc.createElement('meta');
    metaEl.setAttribute('name', 'viewport');
    metaEl.setAttribute('content', 'initial-scale=' + scale + ', maximum-scale=' + scale + ', minimum-scale=' + scale + ', user-scalable=no');
    if (docEl.firstElementChild) {
      docEl.firstElementChild.appendChild(metaEl);
    } else {
      var wrap = doc.createElement('div');
      wrap.appendChild(metaEl);
      doc.write(wrap.innerHTML);
    }
  }

  function refreshRem() {
    var width = docEl.getBoundingClientRect().width;
    if (width / dpr > 540) {
      width = 540 * dpr;
    }
    var rem = width / 10;
    docEl.style.fontSize = rem + 'px';
    flexible.rem = win.rem = rem;
  }

  win.addEventListener('resize', function () {
    clearTimeout(tid);
    tid = setTimeout(refreshRem, 300);
  }, false);
  win.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      clearTimeout(tid);
      tid = setTimeout(refreshRem, 300);
    }
  }, false);

  refreshRem();
  flexible.dpr = win.dpr = dpr;
  flexible.refreshRem = refreshRem;
  flexible.rem2px = function (d) {
    var val = parseFloat(d) * this.rem;
    if (typeof d === 'string' && d.match(/rem$/)) {
      val += 'px';
    }
    return val;
  };
  flexible.px2rem = function (d) {
    var val = parseFloat(d) / this.rem;
    if (typeof d === 'string' && d.match(/px$/)) {
      val += 'rem';
    }
    return val;
  };
})(window, window['lib'] || (window['lib'] = {}));

/***/ }),

/***/ "UJIV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WsQ7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  DNS: 'https://0424bbc2629547e7ada5f0c8127c589c@sentry.lixinio.com/135',
  config: {
    release: '1.0.8',
    logger: 'javascript',
    ignoreUrls: [/sentry\.cheanjiait\.com/],
    environment: "production"
  }
};

/***/ }),

/***/ "Wud8":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("w9lA")

var Component = __webpack_require__("VU/8")(
  /* script */
  null,
  /* template */
  __webpack_require__("1fCB"),
  /* scopeId */
  "data-v-77159c7b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "XYwm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _cache = __webpack_require__("CXu2");

var _cache2 = _interopRequireDefault(_cache);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = {
  phone: ''
};

var mutations = {
  updatePhone: function updatePhone(state, data) {
    state.phone = data;
  },
  getMyCarInfoFromLS: function getMyCarInfoFromLS(state) {
    var phone = _cache2.default.getLocalStorageData('phone') || '';
    if (phone !== '') state.phone = phone;
  },
  setMyCarInfoToLS: function setMyCarInfoToLS(state) {
    _cache2.default.setLocalStorageData('phone', state.phone);
  }
};

var actions = {};

exports.default = {
  state: state,
  mutations: mutations,
  actions: actions
};

/***/ }),

/***/ "YaEn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__("/ocq");

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _vuexRouterSync = __webpack_require__("9JMe");

var _store = __webpack_require__("YtJ0");

var _store2 = _interopRequireDefault(_store);

var _cache = __webpack_require__("CXu2");

var _cache2 = _interopRequireDefault(_cache);

var _config = __webpack_require__("dOCX");

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);

var router = new _vueRouter2.default(_config2.default);

var historyCount = _cache2.default.getSessionData('count') * 1 || 0;
_cache2.default.setSessionData('/', 0);
var commit = _store2.default.commit || _store2.default.dispatch;
router.beforeEach(function (to, from, next) {
  var meta = to.meta || {};

  if (meta && meta.title) {
    changeTitle(meta.title);
  }

  var toIndex = _cache2.default.getSessionData(to.path);
  var fromIndex = _cache2.default.getSessionData(from.path);
  if (toIndex) {
    if (toIndex > fromIndex) {
      commit('UPDATE_DIRECTION', 'forward');
    } else {
      commit('UPDATE_DIRECTION', 'reverse');
    }
  } else {
    ++historyCount;
    _cache2.default.setSessionData('count', historyCount);
    to.path !== '/' && _cache2.default.setSessionData(to.path, historyCount);
    commit('UPDATE_DIRECTION', 'forward');
  }

  if (meta && meta.needLoading) {
    _store2.default.commit('UPDATE_LOADING', {
      status: true,
      text: '加载中...'
    });
  }
  next();
});
(0, _vuexRouterSync.sync)(_store2.default, router);

function changeTitle(title) {
  document.title = title;

  if (navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
    var iframe = document.createElement('iframe');
    iframe.src = '/favicon.ico';
    iframe.style.display = 'none';
    iframe.style.width = '1px';
    iframe.style.height = '1px';
    iframe.onload = function () {
      setTimeout(function () {
        document.body.removeChild(iframe);
      }, 0);
    };
    document.body.appendChild(iframe);
  }
}
exports.default = router;

/***/ }),

/***/ "YtJ0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__("woOf");

var _assign2 = _interopRequireDefault(_assign);

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__("NYxO");

var _vuex2 = _interopRequireDefault(_vuex);

var _veri = __webpack_require__("XYwm");

var _veri2 = _interopRequireDefault(_veri);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

var state = {
  loading: {
    status: false,
    text: '',
    time: 0
  },
  direction: 'forward',
  toast: {
    show: false,
    text: '',
    time: 1000
  },
  report: null,
  authPrefix: '/auth/weixin/'
};

exports.default = new _vuex2.default.Store({
  strict: "production" !== 'production',
  state: state,
  mutations: {
    UPDATE_LOADING: function UPDATE_LOADING(state, loading) {
      state.loading = (0, _assign2.default)({}, state.loading, loading);
    },
    UPDATE_DIRECTION: function UPDATE_DIRECTION(state, direction) {
      state.direction = direction;
    },
    UPDATE_TOAST: function UPDATE_TOAST(state, toast) {
      state.toast = (0, _assign2.default)({}, toast);
    },
    UPDATE_REPORT: function UPDATE_REPORT(state, report) {
      state.report = report;
    }
  },
  actions: {
    UPDATE_TOAST: function UPDATE_TOAST(_ref, toast) {
      var commit = _ref.commit;

      commit('UPDATE_TOAST', toast);
      var st = null;
      clearTimeout(st);
      st = setTimeout(function () {
        toast.show = false;
        commit('UPDATE_TOAST', toast);
      }, toast.time);
    }
  },
  modules: {
    veri: _veri2.default
  }
});

/***/ }),

/***/ "Ze4+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _asyncToGenerator2 = __webpack_require__("exGp");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _calendar = __webpack_require__("uspu");

var _calendar2 = _interopRequireDefault(_calendar);

var _index = __webpack_require__("T5mV");

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      calendar: new _calendar2.default(),
      showCalendar: true
    };
  },

  components: {
    reportHeader: _index2.default
  },
  created: function created() {
    this.week = ['日', '一', '二', '三', '四', '五', '六'];

    this.getCalendarData();
  },
  beforeDestroy: function beforeDestroy() {
    this.timer && clearTimeout(this.timer);
  },

  methods: {
    getCalendarData: function getCalendarData() {
      var _this = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        var _ref, data;

        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$rest.dataReport.getCalendarData(_this.calendar.getYM());

              case 2:
                _ref = _context.sent;
                data = _ref.data;

                _this.calendar.days = _this.calendar.days.map(function (day) {
                  if (data && data.date_info && data.date_info[day.dateStr] === 1) {
                    return (0, _extends3.default)({}, day, { state: 'reported' });
                  }
                  return day;
                });

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    adjacentMonth: function adjacentMonth(direction) {
      var _this2 = this;

      if (!this.calendar.canGetNext() && direction === 'next') return;
      this.showCalendar = false;
      var queryParams = direction === 'prev' ? this.calendar.getPrevDate() : direction === 'next' ? this.calendar.getNextDate() : '';
      if (queryParams === '') return;
      this.timer = setTimeout(function () {
        _this2.showCalendar = true;
        _this2.calendar = new _calendar2.default(new Date(+queryParams.year, +queryParams.month, 0));

        _this2.getCalendarData();
      }, 100);
    },
    handleDayClick: function handleDayClick(_ref2) {
      var year = _ref2.year,
          month = _ref2.month,
          day = _ref2.day,
          state = _ref2.state;

      if (state === 'future') return;
      if (state === 'canReport') {
        this.$router.push({
          path: 'editReport',
          query: { year: year, month: month, day: day }
        });
      }
      if (state === 'reported') {
        this.$router.push({
          path: 'reportDetail',
          query: { year: year, month: month, day: day }
        });
      }
    },
    handleMonthClick: function handleMonthClick() {
      this.$router.push({
        path: 'reportDetail',
        query: this.calendar.getYM()
      });
    },
    calendarTouchStart: function calendarTouchStart(e) {
      this.touch = {};
      this.touch.initiated = true;
      var _e$touches$ = e.touches[0],
          pageX = _e$touches$.pageX,
          pageY = _e$touches$.pageY;

      this.touch.startX = pageX;
      this.touch.startY = pageY;
    },
    calendarTouchMove: function calendarTouchMove(e) {
      if (!this.touch.initiated) {
        return;
      }
      var touch = e.touches[0];
      var deltaX = touch.pageX - this.touch.startX;
      var deltaY = touch.pageY - this.touch.startY;

      if (Math.abs(deltaY) > Math.abs(deltaX)) return;
      this.touch.percent = Math.abs(deltaX / window.innerWidth);
      this.touch.direction = deltaX < 0 ? 'next' : 'prev';
    },
    calendarTouchEnd: function calendarTouchEnd() {
      if (this.touch.percent > 0.2) {
        this.adjacentMonth(this.touch.direction);
      }
    }
  }
};

/***/ }),

/***/ "dOCX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__("E5VZ");

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__("JlJn");

var _index4 = _interopRequireDefault(_index3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    };
  },

  routes: [{
    path: '/',
    redirect: '/login'
  }, {
    path: '/index',
    name: 'Index',
    component: function component(resolve) {
      __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, "MPtL")).then(resolve);
    },

    meta: {
      title: '开发首页'
    }
  }, {
    path: '/login',
    name: 'login',
    component: _index2.default,
    meta: {
      title: '中升二手车业务数据-登录'
    }
  }, {
    path: '/calendar',
    name: 'calendar',
    component: _index4.default,
    meta: {
      title: '中升二手车业务数据-日历'
    }
  }, {
    path: '/reportDetail',
    name: 'reportDetail',
    component: function component(resolve) {
      __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, "vKL2")).then(resolve);
    },

    meta: {
      title: '中升二手车业务数据-详情'
    }
  }, {
    path: '/editReport',
    name: 'editReport',
    component: function component(resolve) {
      __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "dTvT")).then(resolve);
    },

    meta: {
      title: '中升二手车业务数据-编辑'
    }
  }, {
    path: '/success',
    name: 'success',
    component: function component(resolve) {
      __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "mT1c")).then(resolve);
    },

    meta: {
      title: '提交成功'
    }
  }]
};

/***/ }),

/***/ "h6KC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _ravenJs = __webpack_require__("/Hyb");

var _ravenJs2 = _interopRequireDefault(_ravenJs);

var _vue = __webpack_require__("6fN7");

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Report = function () {
  (0, _createClass3.default)(Report, null, [{
    key: 'install',
    value: function install() {}
  }]);

  function Report(Vue) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0, _classCallCheck3.default)(this, Report);

    if (options.config.environment === 'develop') {
      return null;
    } else {
      return _ravenJs2.default.config(options.DNS, options.config).addPlugin(_vue2.default, Vue).install();
    }
  }

  return Report;
}();

exports.default = Report;


function install(Vue) {
  if (install.installed) return;
  install.installed = true;
  Vue.mixin({
    beforeCreate: function beforeCreate() {
      var options = this.$options;
      if (options.report) {
        this.$report = options.report;
      } else if (options.parent && options.parent.$report) {
        this.$report = options.parent.$report;
      }
    }
  });
}

Report.install = install;
Report.version = '__VERSION__';

/***/ }),

/***/ "i4WM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _rest = __webpack_require__("kq8S");

var _rest2 = _interopRequireDefault(_rest);

var _config = __webpack_require__("Jl4W");

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_rest2.default);
exports.default = new _rest2.default({
  rest: _config2.default
});

/***/ }),

/***/ "kq8S":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__("woOf");

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Rest = function () {
  (0, _createClass3.default)(Rest, null, [{
    key: 'install',
    value: function install() {}
  }]);

  function Rest() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck3.default)(this, Rest);

    (0, _assign2.default)(this, options.rest);
  }

  return Rest;
}();

exports.default = Rest;


function install(Vue) {
  if (install.installed) return;
  install.installed = true;
  Vue.mixin({
    beforeCreate: function beforeCreate() {
      var options = this.$options;
      if (options.rest) {
        this.$rest = options.rest;
      } else if (options.parent && options.parent.$rest) {
        this.$rest = options.parent.$rest;
      }
    }
  });
}

Rest.install = install;
Rest.version = '__VERSION__';

/***/ }),

/***/ "l+Iq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _report = __webpack_require__("h6KC");

var _report2 = _interopRequireDefault(_report);

var _config = __webpack_require__("WsQ7");

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_report2.default);
exports.default = new _report2.default(_vue2.default, _config2.default);

/***/ }),

/***/ "q3JJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.mixin({
  methods: {
    showToast: function showToast(text) {
      this.$store.dispatch('UPDATE_TOAST', {
        show: true,
        text: text,
        time: 1000
      });
    },
    switchLoading: function switchLoading(loading) {
      var _this = this;

      window.setTimeout(function () {
        _this.$store.commit('UPDATE_LOADING', {
          status: loading.status || false,
          text: loading.text || ''
        });
      }, loading.time);
    }
  }
});

/***/ }),

/***/ "s22o":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tV7e":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__("woOf");

var _assign2 = _interopRequireDefault(_assign);

var _cvux = __webpack_require__("e55a");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'app',
  components: {
    Loading: _cvux.Loading,
    Toast: _cvux.Toast
  },
  computed: {
    loading: function loading() {
      return this.$store.state.loading;
    },
    direction: function direction() {
      return this.$store.state.direction;
    },
    toast: function toast() {
      var toast = (0, _assign2.default)({}, this.$store.state.toast);
      return toast;
    }
  }
};

/***/ }),

/***/ "tcoz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uspu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BaseDate = function () {
  function BaseDate() {
    var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
    (0, _classCallCheck3.default)(this, BaseDate);

    if (typeof time === 'string') {
      time = new Date(time);
    }

    this.dateObj = time;

    this.timeStamp = this.dateObj.getTime();

    this.year = this.dateObj.getFullYear();

    this.month = this.dateObj.getMonth() + 1 < 10 ? '0' + (this.dateObj.getMonth() + 1) : this.dateObj.getMonth() + 1;

    this.day = this.dateObj.getDate() < 10 ? '0' + this.dateObj.getDate() : this.dateObj.getDate();

    this.dateStr = this.year + '/' + this.month + '/' + this.day;
  }

  (0, _createClass3.default)(BaseDate, [{
    key: 'formatDateStr',
    value: function formatDateStr() {
      var connector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '-';

      if (connector === '/') {
        return this.dateStr;
      }
      return this.dateStr.replace(/\//g, connector);
    }
  }]);
  return BaseDate;
}();

var Calendar = function (_BaseDate) {
  (0, _inherits3.default)(Calendar, _BaseDate);

  function Calendar() {
    var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
    (0, _classCallCheck3.default)(this, Calendar);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Calendar.__proto__ || (0, _getPrototypeOf2.default)(Calendar)).call(this, time));

    _this._midmonth = new Date(_this.year + '/' + _this.month + '/15').getTime();

    _this.frontSpace = new Date(_this.year + '/' + _this.month + '/1').getDay();

    _this.days = _this.getDays();
    return _this;
  }

  (0, _createClass3.default)(Calendar, [{
    key: '_structureYearAndMonth',
    value: function _structureYearAndMonth(midmonth) {
      midmonth = new Date(midmonth);
      return {
        year: new BaseDate(midmonth).year,
        month: new BaseDate(midmonth).month
      };
    }
  }, {
    key: 'getPrevDate',
    value: function getPrevDate() {
      var _prevMidmonth = this._midmonth - 24 * 60 * 60 * 1000 * 30;
      return this._structureYearAndMonth(_prevMidmonth);
    }
  }, {
    key: 'getNextDate',
    value: function getNextDate() {
      var _nextMidmonth = this._midmonth + 24 * 60 * 60 * 1000 * 30;
      return this._structureYearAndMonth(_nextMidmonth);
    }
  }, {
    key: 'getTotalDay',
    value: function getTotalDay() {
      return new Date(this.year, this.month, 0).getDate();
    }
  }, {
    key: 'getYM',
    value: function getYM() {
      return {
        year: this.year,
        month: this.month
      };
    }
  }, {
    key: 'getYMD',
    value: function getYMD() {
      return {
        year: this.year,
        month: this.month,
        day: this.date
      };
    }
  }, {
    key: 'isFuture',
    value: function isFuture(_ref) {
      var year = _ref.year,
          month = _ref.month,
          day = _ref.day;

      return new Date(year + '/' + month + '/' + day).getTime() > new Date().getTime();
    }
  }, {
    key: 'getDays',
    value: function getDays() {
      var _this2 = this;

      var year = this.year,
          month = this.month;

      var days = [];

      var getState = function getState(i) {
        return _this2.timeStamp < new Date('2018/09/01').getTime() ? 'future' : _this2.isFuture((0, _extends3.default)({}, _this2.getYM(), { day: i })) ? 'future' : 'canReport';
      };
      for (var i = 1; i <= this.getTotalDay(); i++) {
        var day = i < 10 ? '0' + i : i;
        days.push((0, _extends3.default)({}, this.getYMD(), {
          day: day,
          dateStr: year + '-' + month + '-' + day,
          state: getState(i)
        }));
      }
      return days;
    }
  }, {
    key: 'getMonthHead',
    value: function getMonthHead() {
      return this.year + '\u5E74' + (this.month + '').replace(/^0/, '') + '\u6708\u4EFD';
    }
  }, {
    key: 'canGetNext',
    value: function canGetNext() {
      var nextDateStr = this.getNextDate().year + '/' + this.getNextDate().month;
      var currentMonthStr = new BaseDate().year + '/' + new BaseDate().month;
      return nextDateStr <= currentMonthStr;
    }
  }]);
  return Calendar;
}(BaseDate);

exports.default = Calendar;

/***/ }),

/***/ "vB6W":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('loading', {
    attrs: {
      "show": _vm.loading.status,
      "text": _vm.loading.text,
      "position": "absolute"
    }
  }), _vm._v(" "), _c('toast', {
    attrs: {
      "type": "text",
      "time": _vm.toast.time
    },
    model: {
      value: (_vm.toast.show),
      callback: function($$v) {
        _vm.$set(_vm.toast, "show", $$v)
      },
      expression: "toast.show"
    }
  }, [_vm._v(_vm._s(_vm.toast.text))]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": 'pop-' + (_vm.direction === 'forward' ? 'in' : 'out')
    }
  }, [_c('router-view', {
    staticClass: "router-view"
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ "w0a6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "w9lA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wG7n":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("中升二手车业务数据")]), _vm._v(" "), _c('form', {
    ref: "loginForm",
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.phone),
      expression: "formData.phone"
    }, {
      name: "blur-validate",
      rawName: "v-blur-validate:textRed",
      value: (['required', 'validatePhone']),
      expression: "['required', 'validatePhone']",
      arg: "textRed"
    }],
    attrs: {
      "type": "tel",
      "name": "phone",
      "maxlength": "11",
      "placeholder": "手机号码"
    },
    domProps: {
      "value": (_vm.formData.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "phone", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item item-picture"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.picCode),
      expression: "formData.picCode"
    }, {
      name: "blur-validate",
      rawName: "v-blur-validate:textRed",
      value: (['required']),
      expression: "['required']",
      arg: "textRed"
    }],
    attrs: {
      "type": "text",
      "name": "picCode",
      "placeholder": "图形验证码"
    },
    domProps: {
      "value": (_vm.formData.picCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "picCode", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "very-pic",
    attrs: {
      "alt": "验证码",
      "src": _vm.veryPic
    },
    on: {
      "click": _vm.getPicCode
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item item-code"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.smsCode),
      expression: "formData.smsCode"
    }, {
      name: "blur-validate",
      rawName: "v-blur-validate:textRed",
      value: (['required']),
      expression: "['required']",
      arg: "textRed"
    }],
    attrs: {
      "type": "number",
      "name": "smsCode",
      "placeholder": "短信验证码"
    },
    domProps: {
      "value": (_vm.formData.smsCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "smsCode", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('button', {
    class: ['get-code', {
      'count-down': _vm.canGetMsm
    }],
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.getMsmCode.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.countText))])])]), _vm._v(" "), _c('button', {
    directives: [{
      name: "check-submit",
      rawName: "v-check-submit:loginForm",
      value: (_vm.login),
      expression: "login",
      arg: "loginForm"
    }],
    staticClass: "login-btn"
  }, [_vm._v("登录")])])
},staticRenderFns: []}

/***/ }),

/***/ "zfoQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__("BO1k");

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _rules = __webpack_require__("TzB0");

var _rules2 = _interopRequireDefault(_rules);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ValidatePlugin = {};
ValidatePlugin.install = function (Vue, options) {
  if (!ValidatePlugin.validation) {
    ValidatePlugin.validation = new _rules2.default();
  }

  Vue.directive('blur-validate', {
    inserted: function inserted(el, binding, vNode) {
      var arg = binding.arg,
          value = binding.value;
      var _ValidatePlugin$valid = ValidatePlugin.validation,
          rules = _ValidatePlugin$valid.rules,
          handleStyles = _ValidatePlugin$valid.handleStyles;

      if (!ValidatePlugin.validation._vm) {
        ValidatePlugin.validation._vm = vNode.context;
      }
      function handleFun(el, vNode) {
        var elName = el.name;
        for (var i = 0; i < value.length; i++) {
          var result = handleStyles[arg](rules[value[i]], el, vNode);
          if (result.pass) {
            ValidatePlugin.validation.delErrorObj(elName);
          } else {
            if (!ValidatePlugin.validation.errorObj[elName]) {
              ValidatePlugin.validation.addErrorObj(elName, el, result.msg);
              return;
            } else {
              ValidatePlugin.validation.errorObj[elName].msg = result.msg;
            }
          }
        }
      }
      el.addEventListener('blur', handleFun.bind(vNode.context, el, vNode), false);
      el.addEventListener('focus', handleStyles['textNormal'].bind(vNode.context, el, vNode), false);
    }
  });
  Vue.directive('check-submit', {
    inserted: function inserted(el, binding, vNode) {
      el.addEventListener('click', function (e) {
        e.preventDefault();

        ValidatePlugin.validation.resetErrorObj();
        var form = vNode.context.$refs[binding.arg];
        if (!form) {
          console.warn('请传入包裹表单元素容器的引用');
          return;
        }
        var elements = form.getElementsByTagName('input');
        var evObj = document.createEvent('Event');
        evObj.initEvent('blur', true, true);
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = (0, _getIterator3.default)(elements), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var element = _step.value;

            element.dispatchEvent(evObj);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        var errorInputs = form.getElementsByClassName('check-error');
        if (errorInputs.length === 0) {
          binding.value();
        } else {
          var firstErrEl = errorInputs[0].getElementsByTagName('input')[0];

          ValidatePlugin.validation._vm.$toast(ValidatePlugin.validation.errorObj[firstErrEl.name].msg);

          document.documentElement.scrollTop = firstErrEl.offsetTop - document.documentElement.clientHeight + 100;
        }
      });
    },
    unbind: function unbind() {
      ValidatePlugin.validation = new _rules2.default();
    }
  });
};

exports.default = ValidatePlugin;

/***/ })

},[1]);


// WEBPACK FOOTER //
// modules/app.c24fe095e9f5e1da0c47.js